// 获取网页名称
export function getHtmlName(){
	let urlParams = window.location.pathname.split('/')
	return urlParams[urlParams.length - 1]
}

// 获取路由参数
export function getQueryParams(variable) {
	let href = window.location.href
	let query = href.substring(href.indexOf("?") + 1)
	let vars = query.split("&")
	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split("=")
		if (pair[0] === variable) {
			return pair[1]
		}
	}
	return (false)
}

// 获取所有路由参数
export function getQueryVariableAll() {
	let href = window.location.href
	let query = href.substring(href.indexOf('?') + 1);
	let vars = query.split("&");
	let obj = {}
	for (var i = 0; i < vars.length; i++) {
		let pair = vars[i].split("=");
		obj[pair[0]] = decodeURI(pair[1])
	}
	return obj;
}

// 修改图标
export const changeFavicon = link => {
	let favicon = document.querySelector('link[rel="icon"]')
	if (favicon !== null) {
		favicon.href = link
	} else {
		favicon = document.createElement("link")
		favicon.rel = "icon"
		favicon.href = link
		document.head.appendChild(favicon)
	}
}
